module.exports = __webpack_public_path__ + "static/img/404.8547ab8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/404.png
// module id = zAji
// module chunks = 1